enum SlotTypes {
    NIVEAU = 'niveau',
    REPEATER = 'repeater',
    GEOMATIQUE = 'geomatique',
    ETOILES = 'etoiles',
    INFO = 'info',
  }

export default SlotTypes;
